var radio = require("react-pubsub-via-radio.js/radio");
var _ = require('lodash');
var Balboa = require('./Balboa');
var esUtils = require('../utils/esUtils');

//key: eid , value: messages array
var messages_by_eid_cache = {};

var wating_on_ajax_eid = {};

var broadcast_all = function(){
	radio('MPMessages_response').broadcast(messages_by_eid_cache);
};

module.exports.init = function(){
	radio('MPMessages_get_for_event').subscribe(_.debounce(function(event_id){
		if((event_id > 0) === false){
			return;
		}
		if(messages_by_eid_cache[event_id]){
			broadcast_all();
			return;
		}
		radio('MPMessages_waiting_on_balboa').broadcast(event_id);
		if(wating_on_ajax_eid[event_id]){
			return;
		}
		wating_on_ajax_eid[event_id] = true;
		Balboa.api('/mpmessage/read', {
			event_id: event_id
		}, function(data){
			messages_by_eid_cache[event_id] = _.map(data.messages, formatMessageFromServer);
			broadcast_all();
			wating_on_ajax_eid[event_id] = false;
		}, function(data){
			console.error(data);
			radio('MPMessages_failed').broadcast(event_id, (data && data.message) || 'unknown cause');
			wating_on_ajax_eid[event_id] = false;
		});
	}, 50));//must debounce b/c race conditions can happen if it's too fast (aka syncronis when expected to be async)

	radio('MPMessages_decache').subscribe(_.debounce(function(event_id){
		delete messages_by_eid_cache[event_id];
	}, 50));

	radio('MPMessages_send_message').subscribe(function(params){
		Balboa.api('/mpmessage/save', params, function(data){
			var message = formatMessageFromServer(data.message);
			if(params.event_id > 0){
				if(!messages_by_eid_cache[params.event_id]){
					messages_by_eid_cache[params.event_id] = [];
				}
				messages_by_eid_cache[params.event_id].unshift(message);
			}
			radio('MPMessages_send_success').broadcast(message);
			broadcast_all();
		}, function(data){
			console.error(data);
			radio('MPMessages_send_failed').broadcast(params, (data && data.message) || 'unknown cause');
		});
	});
};

var formatMessageFromServer = function(message){
	message.created = esUtils.convertFromISO8601(message.created_ISO8601);
	return message;
};



//////////////////
// WEBPACK FOOTER
// ./~/ES/services/MPMessages.js
// module id = 182
// module chunks = 0 1 2 3 4